/* eslint-disable no-redeclare */
import fetchHookFactory from './fetchHookFactory';
import organization_api from '@/api/organization_api';

export const [useApiKeyListApi, refreshApiKeyListApi] = fetchHookFactory(async () => {
  return organization_api.getApiKeyList();
}, 'cache');
